module.exports = "/images/vendor/flag-icon-css/flags/4x3/kh.svg?5a13865d2bcaa01d31483c08c8903ea7";